import { Box, Flex, Stack } from '@chakra-ui/react'
import { motion, type Transition } from 'framer-motion'

// Animation config
export const springConfig: Transition = { type: 'spring' as const, stiffness: 100, damping: 20 }

// Animation variants
export const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 0.1 }
  }
}

export const itemVariants = {
  hidden: { opacity: 0, x: -20, scale: 0.95 },
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: { ...springConfig, damping: 15 }
  }
}

export const expandedItemVariants = {
  hidden: { opacity: 0, x: -30, scale: 0.9, height: 0 },
  visible: (index: number) => ({
    opacity: 1,
    x: 0,
    scale: 1,
    height: '40px',
    transition: {
      ...springConfig,
      damping: 15,
      delay: index * 0.15 // Stagger animation based on index
    }
  }),
  exit: {
    opacity: 0,
    x: -20,
    scale: 0.95,
    height: 0,
    transition: { duration: 0.3 }
  }
}

export const barVariants = {
  hidden: { width: 0 },
  visible: ({ percentage, delay }: { percentage: number, delay: number }) => ({
    width: `${percentage}%`,
    transition: { ...springConfig, stiffness: 80, delay }
  })
}

// Motion components
export const MotionStack = motion(Stack)
export const MotionFlex = motion(Flex)
export const MotionBox = motion(Box)
